import React from 'react';
import "./HomeBannerStyle.css";
import cartoon from "../images/cartoon-girl.png";


export default function HomeBanner({id}) {
  return (
    <div className="home" id={id}> 
        <div className='content'>
            <div className="wrapper">
              <div className="name">Maria Cornea</div>
              <div className="staticTitle">
                Front-end
                <div className='hrLine'></div>
              </div>
              <ul className="dynamicTitle">
                <li>+<span>Developer</span></li>
              </ul>
              <a className='btn, hire-btn' href="https://www.linkedin.com/in/maria-corban/" target="_blank" rel="noopener noreferrer">Hire Me</a>
            </div>
        </div>
        <div className="mask">
            <img className='bg' src={cartoon} alt="girl-with-laptop" />
        </div>
    </div>
  )
}
